module.exports = __webpack_public_path__ + "img/0Q3A7268_L_Wood_MockedUp.c8a4fdb3.jpg";